import React from 'react';
import { motion } from 'framer-motion';
import styles from './CarouselDropzone.module.scss';
import dropzoneImage from '../../icons/prefilled/dropzoneImage.svg';
import SVGIcon from '../../components/SVGIcon';

interface CarouselDropzoneProps {
  width: number;
}

const CarouselDropzone = ({ width }: CarouselDropzoneProps) => {
  return (
    <motion.div
      className={styles.container}
      initial={{ opacity: 0, width: 0 }}
      animate={{
        opacity: 1,
        width,
      }}
      transition={{
        type: 'spring',
        damping: 30,
        stiffness: 300,
        mass: 0.2,
      }}
    >
      <SVGIcon size={28}>{dropzoneImage}</SVGIcon>
      <div className={styles.label}>Drop images to upload</div>
    </motion.div>
  );
};

export default CarouselDropzone;
